import { TabElement, TabsContainer } from './Tabs.styled';

export interface Tab {
  label: string;
  value: string;
  isDisabled?: boolean;
}

export interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  setActiveTab: (value: string) => void;
  className?: string;
}

const Tabs = ({ tabs, activeTab, setActiveTab, className }: TabsProps) => (
  <TabsContainer className={className}>
    {tabs.map(({ label, value, isDisabled }) => (
      <TabElement
        aria-selected={activeTab === value}
        disabled={isDisabled}
        key={value}
        tabIndex={activeTab === value || isDisabled ? -1 : 0}
        onClick={event => {
          event.currentTarget.blur();
          setActiveTab(value);
        }}>
        {label}
      </TabElement>
    ))}
  </TabsContainer>
);

export default Tabs;
